import React from 'react'
import { Link } from 'react-router-dom'
import { APP_NAME } from '../../brand'

class Privacy extends React.Component {
  render() {
    return (
      <div className="ng-legal">
        <div className="ng-legal-nav">
          <Link to="/tos" className="ng-legal-tab">Terms of Service</Link>
          <Link to="/privacy" className="ng-legal-tab ng-legal-tab--active">Privacy Policy</Link>
        </div>

        <div className="ng-legal-hero">
          <div className="ng-legal-icon">🔒</div>
          <h1>Privacy Policy</h1>
          <p className="ng-legal-subtitle">Last updated: August 2026</p>
        </div>

        <div className="ng-legal-body">
          <section className="ng-legal-section">
            <h2>1. Introduction</h2>
            <p>
              <strong>{APP_NAME}</strong> respects your privacy and is committed to
              protecting your personal data. This policy explains what we collect, how we
              use it, and the choices you have when using our showing marketplace.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>2. Data we collect</h2>
            <div className="ng-legal-grid">
              <div className="ng-legal-card">
                <h3>Data you provide</h3>
                <ul>
                  <li>Name and email address</li>
                  <li>Phone number</li>
                  <li>Real-estate license details (number, state, brokerage)</li>
                  <li>Coverage area for showing agents</li>
                  <li>Showing requests, reports, reviews, and messages</li>
                </ul>
              </div>
              <div className="ng-legal-card">
                <h3>Data collected automatically</h3>
                <ul>
                  <li>IP address and browser type</li>
                  <li>Pages visited and session length</li>
                  <li>Device and operating-system information</li>
                  <li>Approximate location (and precise location if you grant it, to show nearby jobs)</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="ng-legal-section">
            <h2>3. How we use your data</h2>
            <ul>
              <li><strong>Operating the marketplace</strong> — matching showing requests with nearby agents, exchanging contact details between the two agents of an accepted showing, and delivering notifications.</li>
              <li><strong>Trust and safety</strong> — verifying real-estate licenses, handling abuse reports, and enforcing our Terms.</li>
              <li><strong>Communication</strong> — transactional email and push notifications about your showings and account.</li>
              <li><strong>Improvement</strong> — aggregate, de-identified usage statistics.</li>
            </ul>
            <p>We do not sell your personal data.</p>
          </section>

          <section className="ng-legal-section">
            <h2>4. What other users see</h2>
            <p>
              Your name and rating are visible on your postings and acceptances. Your
              email and phone number are shared only with the other agent of a showing you
              posted or accepted. Property access notes are visible only to the agent who
              accepted that showing.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>5. Data retention and deletion</h2>
            <p>
              You can delete your account from your profile at any time. On deletion your
              contact details, credentials, and device tokens are removed from your
              account record. Records of completed showings and reviews are retained as
              required for the other party's business records and by applicable law. To
              exercise data rights (access, correction, deletion), contact support from
              within the app.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>6. Security</h2>
            <p>
              Passwords are stored hashed, transport is encrypted, and access to
              production data is restricted. No system is perfectly secure — notify us
              immediately if you suspect unauthorized access to your account.
            </p>
          </section>

          <section className="ng-legal-section">
            <h2>7. Changes to this policy</h2>
            <p>
              We may update this policy; material changes will be announced at least 30
              days before taking effect.
            </p>
          </section>
        </div>
      </div>
    )
  }
}

export default Privacy
